import React from 'react';
import {FmlxStatusbarContainer} from 'fmlx-common-ui';

import useShowStatusbar from 'lib/hooks/useShowStatusbar';

import InstrumentStatus from 'contents/InstrumentStatus/InstrumentStatus';
import {selectIsHumidifierInstalled} from 'stores/selectors/humidifierSelectors';
import {useSelector} from 'react-redux';
import style from './FastStatusBar.module.scss';
import HumidifierRuntime from '../HumidityControl/HumidifierRuntime';

function FastStatusbar() {
  const shouldShowStatusbar = useShowStatusbar();
  const isHumidifierInstalled = useSelector(selectIsHumidifierInstalled);

  if (!shouldShowStatusbar) return null;

  return (
    <div className={style.container}>
      <FmlxStatusbarContainer alignment={FmlxStatusbarContainer.Alignment.RIGHT}>
        {isHumidifierInstalled && <HumidifierRuntime />}
        <InstrumentStatus />
      </FmlxStatusbarContainer>
    </div>
  );
}

export default FastStatusbar;
